import React, { useState, useEffect } from "react";
import Img from "gatsby-image";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  VegStickerBigger,
  VeganStickerBigger,
  ProteinStickerBigger,
} from "../../imageComponents/diet_stickers";
import { Autoplay, Pagination, Navigation } from "swiper";
import Plx from "react-plx";

const ImageWithBorder = ({ image, name, outline }) => {
  return (
    <div className="salad-slide">
      <div className="motion-lines">
        <Img
          fluid={outline}
          alt={name}
          placeholder="blurred"
          height={445}
          width={445}
        />
      </div>
      <div className="salad-image">
        <Img
          fluid={image}
          alt={name}
          placeholder="blurred"
          height={600}
          width={600}
        />
      </div>
    </div>
  );
};

const Carousel = ({ slides, images, lang }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  let cancelTimeOutAddClass, cancelTimeOutRemoveClass;
  const getCarouselSlide = (slide) => {
    let { name, image } = slide;
    let motionName = image.split(".").join("_motion.");
    return (
      <ImageWithBorder
        image={images[image]}
        name={name[lang]}
        outline={images[motionName]}
      />
    );
  };
  useEffect(() => {
    return () => {
      if (cancelTimeOutAddClass) {
        clearTimeout(cancelTimeOutAddClass);
      }
      if (cancelTimeOutRemoveClass) {
        clearTimeout(cancelTimeOutRemoveClass);
      }
    };
  }, []);
  const handleChange = (event) => {
    const index = event.realIndex || 0;
    setActiveSlide(index);
    cancelTimeOutAddClass = setTimeout(() => {
      let centerElem = document.querySelector(".swiper-slide-active");
      centerElem.classList.add("animate");
      cancelTimeOutRemoveClass = setTimeout(() => {
        centerElem.classList.remove("animate");
      }, 1000);
    }, 500);
  };
  const getCarouselSpacing = () => {
    const documentWidth =
      typeof window !== "undefined" ? document.body.clientWidth : 0;
    if (documentWidth <= 600) {
      return 55;
    } else if (documentWidth <= 1024) {
      return 150;
    } else if (documentWidth < 1800) {
      return 300;
    }
    return 600;
  };
  const getSticker = (item) => {
    if (item.is_vegetarian) {
      return <VegStickerBigger />;
    } else if (item.is_vegan) {
      return <VeganStickerBigger />;
    } else if (item.protein_boost) {
      return <ProteinStickerBigger />;
    }
    return null;
  };
  const parallaxRotate = [
    {
      start: "self",
      duration: 2000,
      properties: [
        {
          startValue: 0,
          endValue: 360,
          property: "rotate",
        },
      ],
    },
  ];
  return (
    <div className="swiper-container">
      <Swiper
        className="carousel-swiper"
        slidesPerView={"auto"}
        loop={true}
        spaceBetween={getCarouselSpacing()}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        centeredSlides={true}
        onActiveIndexChange={handleChange}
      >
        {slides.map((slide, index) => {
          return (
            <SwiperSlide className={`slide-${index}`} key={`slide-${index}`}>
              {getCarouselSlide(slide, index)}
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="information-container">
        {slides.map((slide, index) => {
          let { name, description } = slide;
          return (
            <div
              key={`info-${index}`}
              className={`slide-info info-${index} ${
                activeSlide === index ? "active" : ""
              }`}
            >
              <div className="name-description">
                <h2 className="name desktop:desktop-h2 tablet:mobile-h2 mobile:mobile-h2">
                  <span>{name[lang]}</span>
                  <div className="bg"></div>
                </h2>
                <p className="description desktop:desktop-body2 tablet:mobile-body2 mobile:mobile-body2">
                  {description[lang]}
                </p>
              </div>
              <div className="sticker">
                <Plx parallaxData={parallaxRotate}>{getSticker(slide)}</Plx>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Carousel;
